import React, { createContext, useContext, useMemo } from 'react';
import { useConfigContext } from '../../../config/ConfigContext';
import { makeSsoGatewayClient, SsoGatewayClient } from './client';

const context = createContext<SsoGatewayClient>(undefined);

export const SsoGatewayProvider: React.FC<{ value?: SsoGatewayClient }> = (props) => {
  const { frontendSsoGateway } = useConfigContext()?.authentication || {};
  const value = useMemo(() => makeSsoGatewayClient(frontendSsoGateway), [frontendSsoGateway]);

  return <context.Provider value={value} {...props} />;
};

export const useSsoGateway = () => useContext(context);
